import { render, staticRenderFns } from "./popularProduct.vue?vue&type=template&id=148a8b5c&scoped=true&v-if=product"
import script from "./popularProduct.vue?vue&type=script&lang=js"
export * from "./popularProduct.vue?vue&type=script&lang=js"
import style0 from "./popularProduct.vue?vue&type=style&index=0&id=148a8b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148a8b5c",
  null
  
)

export default component.exports